<template>

	<div class="list-content">
		<div class="faq-list type-accordion">
			<dl v-for="(item, index) in boardList" :id="'item-' + item.idx">
				<dt :style="{ color : item.opt3 }" @click="openAnwer($event, item)" :id="'dt-' + item.idx">
					<em class="cate">{{ item.cateName }}</em>
					<h3 class="tit">{{ item.title }}</h3>
				</dt>
				<dd>
					<div class="answer-q">
<!--						<html-open :targetId="'answer_q_' + item.idx" :ref="'answer_q_' + item.idx" :html-code="item.contentHtml"></html-open>-->
						<summernote-frame :targetId="'answer_q_' + item.idx" :ref="'answer_q_' + item.idx" mode="view" :html="item.contentHtml"></summernote-frame>
					</div>
<!--					<html-open :target-id="'html-' + item.idx" :html-code="stringUtils.nl2br(item.contentHtml)"></html-open>-->

					<template v-if="item.answer != null " >
						<div class="answer-a m-t-20">
<!--							<html-open :targetId="'answer_a_' + item.idx" :ref="'answer_a_' + item.idx" :html-code="item.answer.contentText"></html-open>-->
							<summernote-frame :targetId="'answer_a_' + item.idx" :ref="'answer_a_' + item.idx" mode="view" :html="item.contentHtml"></summernote-frame>
						</div>
					</template>
				</dd>
			</dl>


			<!--<dl>
				<dt>
					<em class="cate">오류</em>
					<h3 class="tit">속에서 생명을 불러 인생의 사는가 작고 때문이다. 노년에게서 것은 튼튼하며, 고동을 과실이 있으랴.</h3>
				</dt>
				<dd>
					<div class="answer">
						눈에 그들의 창공에 따뜻한 보이는 많이 끓는 그것은 것이다. 속에서 그들의 보배를 인도하겠다는 하는 품으며, 철환하였는가? 구하기 없으면, 더운지라 얼음에 얼음이 우리 되려니와, 천자만홍이 무엇을 봄바람이다. 만물은 청춘의 곳이 황금시대다. 만물은 원질이 사는가 것이다. 산야에 예가 옷을 것이다.
					</div>
				</dd>
			</dl>
			<dl>
				<dt>
					<em class="cate">소프트웨어</em>
					<h3 class="tit">실로 간에 찾아 무엇을 동력은 사막이다. 가는 방황하여도, 청춘의 미인을 예가 그들에게 듣는다.</h3>
				</dt>
				<dd>
					<div class="answer">
						있는 소금이라 방황하였으며, 있을 황금시대를 못하다 얼마나 맺어, 속잎나고, 때문이다. 인생에 위하여서 무엇을 쓸쓸한 열락의 같으며, 스며들어 것이다. 물방아 인생에 이상의 보라. 새 그들의 타오르고 바이며, 품에 앞이 것이다. 인생에 얼마나 인생을 이성은 안고, 무엇이 인간에 청춘을 봄바람이다. 그들의 우리 두기 대한 미묘한 인간에 보이는 이상의 아름다우냐? 긴지라 살았으며, 이 황금시대다.
					</div>
				</dd>
			</dl>-->

		</div>
	</div>

</template>

<script>

import $ from 'jquery'
import SummernoteFrame from "@/components/display/summernoteFrame";

export default {
	name: "listFaq",
	components: {SummernoteFrame},
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		boardInfo: Object,
		noticeList: Array,
		boardList: Array,
	},
	data() {

		return {

		}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		goBoardOne( _idx ) {
			this.$emit("goBoardOne", _idx);
		},

		openAnwer(e, _item) {

			console.log( e.currentTarget.id )
			const dom = "#" + e.currentTarget.id

			// 아코디언 리스트
			$(".type-accordion dd").hide();
			if (!$(dom).parent("dl").hasClass("active")) {
				$(".type-accordion dl").removeClass("active");
				$(".type-accordion dd").slideUp(250);
				$(dom).parent("dl").addClass("active");
				$(dom).siblings("dd").slideDown(250);

				/*for (let answerQKey in this.$refs.answer_q) {
					this.$refs.answer_q[answerQKey].frameResize()
				}
				for (let answerAKey in this.$refs.answer_a) {
					this.$refs.answer_a[answerAKey].frameResize()
				}*/
				// this.$refs.answer_q.frameResize()
				// this.$refs.answer_a.frameResize()
				this.webUtils.scrollTo(dom);

				this.$refs['answer_q_' + _item.idx][0].frameResize()
				if ( _item.answer != null ) {
					this.$refs['answer_a_' + _item.idx][0].frameResize()
				}

			} else {
				$(dom).parent("dl").removeClass("active");
				$(dom).siblings("dd").slideUp(250);
			}
		},


	},
	watch: {
		'boardList': (newVal, oldVal) => {
			//console.log( newVal )
		}
	}
}
</script>

<style scoped>

</style>
